import { render, staticRenderFns } from "./NumberScrub.vue?vue&type=template&id=ac0d8544&scoped=true"
import script from "./NumberScrub.vue?vue&type=script&lang=js"
export * from "./NumberScrub.vue?vue&type=script&lang=js"
import style0 from "./NumberScrub.vue?vue&type=style&index=0&id=ac0d8544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0d8544",
  null
  
)

export default component.exports